import { useAppSelector } from "@momentum/redux-store";
import { selectMomentumApiSlice } from "@momentum/momentum-api";
import { selectRealtimeApiSlice } from "@momentum/realtime-api";
import { createSelector } from "@reduxjs/toolkit";
import { Command } from "cmdk";

const selectAllQueries = createSelector(
  [selectMomentumApiSlice, selectRealtimeApiSlice],
  (momentumApi, realtimeApi) => ({
    ...(momentumApi?.queries ?? {}),
    ...(realtimeApi?.queries ?? {}),
  })
);

export function QueryDataPage() {
  const queries = useAppSelector(selectAllQueries);

  return (
    <div>
      {Object.keys(queries).map((key) => (
        <Command.Item
          key={key}
          className="text-grey-70 p-1 body-12 rounded-md data-[selected=true]:bg-lvl-2"
          onSelect={() => {
            console.log(queries[key]?.data);
          }}
        >
          {key}
        </Command.Item>
      ))}
    </div>
  );
}
